import template from './eventProductPage.html';
import controller from './eventProductPage.controller';

let eventProductPageComponent = {
  restrict: 'E',
  template,
  controller,
  controllerAs: 'vm',
  bindings: {
    eventProducts: '<',
    issueTypes: '<',
    onSave: '&',
    onBack: '&',
    isSaving: '<',
  }
};

export default eventProductPageComponent;
